import React, {Component} from 'react';
import {observer} from 'mobx-react';
import withClickOutside from 'react-onclickoutside';
import {moveFieldToAnotherTab} from '../derivatives/TreeDesign/actions/Collection';
import {MenuProps} from './DesignMenu';
import {AnimatedActionSubmenu} from '../../../../components/Common/ActionsMenu/ActionSubmenu';
import chosen from '../../../../images/chosen.png';

@observer
class MoveMenu extends Component<MenuProps & any, any> {
    constructor(props) {
        super(props);

        this.moveField = this.moveField.bind(this);
    }

    moveField(selectedTab) {
        const {field} = this.props;
        moveFieldToAnotherTab(field, selectedTab);
    }

    handleClickOutside() {
        const {closeSubmenu} = this.props;
        closeSubmenu();
    }

    render() {
        const {field} = this.props;
        const {screen} = field;
        return (
            <AnimatedActionSubmenu open={this.props.open}>
                {field.type !== 'tab' && // do we need this check?
                    screen.collection.fields.map(tab => {
                        return (
                            <div
                                key={tab.name}
                                className={`move-option ${
                                    field.parentField.name === tab.name && 'selected'
                                }`}
                                onClick={() => this.moveField(tab.name)}
                            >
                                <img src={chosen} alt="" />
                                {tab.title}
                            </div>
                        );
                    })}
            </AnimatedActionSubmenu>
        );
    }
}

const MoveSubmenu = withClickOutside(MoveMenu);

export default MoveSubmenu;
